export const userListSteps = [
  {
    element: '#userlist',
    popover: {
      title: 'View Users  ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li>The table shows user Name, Email, Role, and Status.</li> </ul></div>',
    },
  },
  {
    element: '#searchuser',
    popover: {
      title: 'Search Users  ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Enter name/email in the search bar.</li> </ul></div>',
    },
  },

  // {
  //     element: '#resetuserpass',
  //     popover: {
  //     title: 'Reset Password ',
  //     showButtons: ['previous', 'next', 'close'],
  //     description: '<div><ul><li>Click Reset Password for a password‐reset link.</li></ul></div>',
  //     },

  // },
  {
    element: '#userstatusfilter',
    popover: {
      title: 'Filter by Status',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Toggle Active or Inactive to change the user list view.</li></ul></div>',
    },
  },
  {
    element: '#adduser',
    popover: {
      title: 'Add New User ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Use the ADD button to register another user.</li></ul></div>',
    },
  },
]

export const addUserSteps = [
  {
    element: '#userbasicdetailsform',
    popover: {
      title: 'Enter Basic Details  ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> Provide Email, First Name, Last Name.</li> </ul></div>',
    },
  },

  {
    element: '#userroleform',
    popover: {
      title: 'Select a Role',
      showButtons: ['previous', 'next', 'close'],
      description: '<div><ul><li>Select a Role </li></ul></div>',
    },
  },
  {
    element: '#userprofileform',
    popover: {
      title: '(Optional) Upload Profile Image ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Drag or click to upload a user photo. </li></ul></div>',
    },
  },
  {
    element: '#saveuser',
    popover: {
      title: ' Add the User',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Click Add. The user will get an email to set their password if configured.</li></ul></div>',
    },
  },
]
